export default theme => ({
  root: {
    ...theme.flexColumnCenter,
    justifyContent: 'flex-start',
    height: '100%',
    width: '100%',
    fontWeight: 400,
    paddingTop: '1.5rem'
  },
  panel: {
    ...theme.flexColumnCenter,
    flexGrow: 1,
    padding: '1.25rem',
    minWidth: '250px',
    minHeight: '270px',
    boxShadow: 'none',
    height: '100%'
  },
  orLabel: {
    marginTop: '1rem',
    marginBottom: '.5rem'
  },
  login: {
    ...theme.flexColumnCenter,
    justifyContent: 'center',
    marginTop: '1.5rem'
  },
  loginLabel: {
    fontSize: '1rem',
    fontWeight: 'bold'
  },
  loginLink: {
    fontSize: '1.2rem'
  },
  providers: {
    marginTop: '1rem'
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: 'center',
    color: theme.palette.text.secondary
  },
  container1200px: {
    marginTop: 30,
    maxWidth: 1200,
    minHeight: '500px',
    backgroundColor: '#fff'
  },
  gridPadding: {
    paddingLeft: 20,
    paddingRight: 20
  },
  subtitle: {
    fontWeight: 300
  },
  familyImage: {
    width: '100%',
    maxWidth: '13rem',
    marginTop: '3rem',
    height: 'auto',
    cursor: 'pointer'
  }
});
